import React, { useEffect, useRef } from 'react';
import '../Style.css';

const OurTech = () => {
   // Refs for h1 and p elements
   const h1Ref = useRef(null);
   const pRef = useRef(null);
 
   useEffect(() => {
     const observer = new IntersectionObserver(
       ([entry], observerInstance) => {
         if (entry.isIntersecting) {
           // Add 'active' class when element comes into view
           entry.target.classList.add('active');
 
           // Stop observing after first trigger
           observerInstance.unobserve(entry.target);
         }
       },
       { threshold: 0.1 } // trigger when 10% visible
     );
 
     if (h1Ref.current) {
       observer.observe(h1Ref.current);
     }
     if (pRef.current) {
       observer.observe(pRef.current);
     }
 
     return () => observer.disconnect(); // clean up
   }, []);


  return (
    <>
      <div className="container">
        <div className="tut">
          <h1 className="slide-up h1-active" ref={h1Ref}>Our Tech Stack</h1>
          <p className="slide-up p-active" ref={pRef}>At HatchCoders, we use modern, scalable, and secure technologies to build high-performance digital solutions.</p>
        </div>

        <div className="tech">
          {/* Mobile Development */}
          <div className="left-tech">
            <h2>Mobile development</h2>
            <p>Frontend</p>

            <div className="dev-flx">
              <div className="mobimg">
                <img src="/Images/mob1.webp" alt="img" />
                <p>Swift</p>
              </div>

              <div className="mobimg">
                <img src="/Images/mob2.webp" alt="img" />
                <p>objC</p>
              </div>

              <div className="mobimg">
                <img src="/Images/mob3.webp" alt="img" />
                <p>Kotlin</p>
              </div>
            </div>

            <br />
            <p>Hybrid</p>
            <div className="dev-flx">
              <div className="mobimg">
                <img src="/Images/mob4.webp" alt="img" />
                <p>Flutter</p>
              </div>

              <div className="mobimg">
                <img src="/Images/mob5.webp" alt="img" />
                <p>React Native</p>
              </div>
            </div>
          </div>

          {/* Web Development */}
          <div className="Right-tech">
            <h2>Web development</h2>
            <p>Frontend</p>

            <div className="dev-flx">
              <div className="mobimg">
                <img src="/Images/mob5.webp" alt="img" />
                <p>React.js</p>
              </div>

              <div className="mobimg">
                <img src="/Images/mob22.webp" alt="img" />
                <p>Angular</p>
              </div>

              <div className="mobimg">
                <img src="/Images/mob33.webp" alt="img" />
                <p>Vue.js</p>
              </div>
            </div>

            <br />
            <p>Backend</p>
            <div className="dev-flx">
              <div className="mobimg">
                <img src="/Images/mob6.webp" alt="img" />
                <p>Node.js</p>
              </div>

              <div className="mobimg">
                <img src="/Images/mob7.webp" alt="img" />
                <p>TypeScript</p>
              </div>

              <div className="mobimg">
                <img src="/Images/mob8.webp" alt="img" />
                <p>.Net</p>
              </div>

              <div className="mobimg">
                <img src="/Images/mob9.webp" alt="img" />
                <p>Python</p>
              </div>

              <div className="mobimg">
                <img src="/Images/mob10.webp" alt="img" />
                <p>Java</p>
              </div>

              <div className="mobimg">
                <img src="/Images/mob11.webp" alt="img" />
                <p>PHP</p>
              </div>
            </div>
          </div>
        </div>

        {/* Game Development */}
        <br />
        <br />
        <div className="tech">
          <div className="left-tech">
            <h2>Mobile Game Development</h2>
            <p>Frontend</p>

            <div className="dev-flx">
              <div className="mobimg">
                <img src="/Images/mb1.webp" alt="img" />
                <p>Unity 3D</p>
              </div>

              <div className="mobimg">
                <img src="/Images/mb2.webp" alt="img" />
                <p>Unreal</p>
              </div>

              <div className="mobimg">
                <img src="/Images/mb3.webp" alt="img" />
                <p>AR/VR</p>
              </div>

              <div className="mobimg">
                <img src="/Images/mb4.webp" alt="img" />
                <p>Godot</p>
              </div>
            </div>
          </div>

          <div className="Right-tech">
            <h2>Web Game Development</h2>
            <p>Frontend</p>

            <div className="dev-flx">
              <div className="mobimg">
                <img src="/Images/mb5.webp" alt="img" />
                <p>Phaser</p>
              </div>

              <div className="mobimg">
                <img src="/Images/mb6.webp" alt="img" />
                <p>Construct2/3</p>
              </div>

              <div className="mobimg">
                <img src="/Images/mb7.webp" alt="img" />
                <p>Three.js</p>
              </div>

              <div className="mobimg">
                <img src="/Images/mb8.webp" alt="img" />
                <p>Cocos-Creator</p>
              </div>

              <div className="mobimg">
                <img src="/Images/mb9.webp" alt="img" />
                <p>Pixi.js</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OurTech;
